module.exports = __webpack_public_path__ + "img/reims-logo-icon.80677ba8.png";